import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { addNewsAndEventsRequest, addNewsAndEventsRequestError, addNewsAndEventsRequestSuccess } from '../../slices/NewsAndEvents/AddNewsAndEventsSlice';

export const AddNewsAndEventsAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(addNewsAndEventsRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.addNewsAndEvents,
                data: data,
            })
            return dispatch(addNewsAndEventsRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(addNewsAndEventsRequestError(_error));
        }
    };
};
